import React from 'react'
import PropTypes from 'prop-types'

import {
  Box, DashboardModule,
} from '@domain-group/suit-theme'

import LogoListItem from '@components/LogoListItem'

const Logos = (props) => {
  const { providerPayload } = props

  const {
    callbacks: { uploadLogo },
    loading,
    provider: {
      logo,
      alternate_logo,
    },
  } = providerPayload

  return (
    <DashboardModule loading={loading} title="Logos">
      {!loading && (
        <Box flexDirection="column">
          <LogoListItem
            callbacks={{ uploadLogo: () => uploadLogo({ type: 'logo' }) }}
            logo={logo}
            size="(400x400 PNG)"
            title="Logo"
          />

          <LogoListItem
            callbacks={{ uploadLogo: () => uploadLogo({ type: 'alternate_logo' }) }}
            logo={alternate_logo}
            size="(800x480 PNG)"
            title="Alternate Logo"
          />
        </Box>
      )}
    </DashboardModule>
  )
}

Logos.propTypes = {
  providerPayload: PropTypes.object.isRequired,
}

export default Logos
